import { createStyles } from '@mantine/styles';

var useStyles = createStyles(() => ({
  placeholder: {},
  input: {
    cursor: "pointer"
  }
}));

export default useStyles;
//# sourceMappingURL=FileInput.styles.js.map
